<template>
  <inertia-link :href="route(routeLink)">
    <div>
      <h2
        class="font-semibold text-xl leading-tight"
        :class="getClassMenu( routeLink)"
      >
        {{title}}
      </h2>
    </div>
  </inertia-link>

</template>

<script>
export default {
  props: ['title', 'routeLink'],
  methods: {
    getClassMenu(currentRoute) {
      return route().current(currentRoute) ? 'text-gray-800' : 'text-gray-400';
    }
  }
}
</script>

<style>
</style>
